import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ModalCard } from 'partial/components/Modal';
import FormInput from 'partial/components/form/FormInput';

import AsyncButton from 'modules/common/components/AsyncButton';
import { useAddRole, useEditRole } from '../hooks';

const AddUpdateRole = ({ onClose, type, prevData }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const [fields, setFields] = useState({
    name: prevData?.name || '',
    code: prevData?.code || '',
  });

  const isFieldEmpty = useMemo(
    () => !fields?.name?.length || !fields?.code?.length,
    [fields],
  );

  const onError = () => setPending(false);
  const onSuccess = (res) => {
    setPending(false);
    onClose();
    navigate(`/access-control/roles-and-permissions/${res?.data?.data?.id}`);
  };

  const [isAddLoading, add] = useAddRole(onSuccess, onError);
  const [isEditLoading, edit] = useEditRole(onSuccess, onError);

  const isLoading = pending || isAddLoading || isEditLoading;

  const handleSubmit = (e) => {
    e.preventDefault();

    setPending(true);

    if (type === 'add') add(fields);
    if (type === 'edit') edit({ ...fields, id: prevData?.id });
  };

  return (
    <ModalCard size="sm" title="ADD ROLE" onClose={onClose}>
      <form className="px-4 py-6" onSubmit={handleSubmit}>
        <div className="space-y-6">
          <FormInput
            name="name"
            onChange={setFields}
            value={fields?.name}
            label="Role"
            type="text"
            required
          />

          <FormInput
            name="code"
            onChange={setFields}
            value={fields?.code}
            label="Code"
            type="text"
            required
          />
        </div>
        <div className="flex justify-end gap-2 mt-10">
          <AsyncButton
            color="regular"
            className="!text-gray-500 font-[400]"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            color="regular"
            type="submit"
            className="font-[400]"
            disabled={isFieldEmpty || isLoading}
            isLoading={isLoading}
          >
            {type === 'add' ? 'add' : 'save'}
          </AsyncButton>
        </div>
      </form>
    </ModalCard>
  );
};

AddUpdateRole.defaultProps = {
  type: 'add',
  prevData: {},
};

AddUpdateRole.propTypes = {
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string,
  prevData: PropTypes.instanceOf(Object),
};

export default AddUpdateRole;
